import { Box, TextField } from "@mui/material";
import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "store";
import { useTranslation } from "react-i18next";
import actions, { createCollectionFromSound } from "store/eventSounds/actions";
import { Form } from "react-final-form";
import { ModalWrap } from "./modal";
import { useStyles } from "./styles";

const SaveCollectionClassModal = () => {
  const {
    openSelectAllResults,
    placementTypeValues,
    machineTypeValues,
    failureTypeValues,
    eventTypeValues,
    machineValues,
    labelStart,
    labelEnd,
    isEvent,
    isLabel,
    labelSubcategoryValues,
    minValue,
    maxValue,
    q,
  } = useSelector((state: AppState) => state.eventSounds);
  const { t } = useTranslation();
  const dispatch: any = useDispatch();
  const [nameValue, setNameValue] = useState<string>("");

  const classes = useStyles();

  const onCancel = () => {
    dispatch(actions.setOpenSelectAllResults(false));
  };

  const onSubmit = useCallback(() => {
    dispatch(
      createCollectionFromSound({
        name: nameValue,
        search_events: isEvent,
        search_labels: isLabel,
        machine: machineValues,
        from: labelStart ? new Date(labelStart).toISOString() : null,
        to: labelEnd ? new Date(labelEnd).toISOString() : null,
        eventType: eventTypeValues,
        machineSubcategory: machineTypeValues,
        placementType: placementTypeValues,
        failureType: failureTypeValues,
        q,
        labelSubcategory:
          labelSubcategoryValues && labelSubcategoryValues.length
            ? labelSubcategoryValues
            : null,
        value_min: minValue,
        value_max: maxValue,
      })
    );
  }, [
    dispatch,
    nameValue,
    openSelectAllResults,
    placementTypeValues,
    machineTypeValues,
    failureTypeValues,
    eventTypeValues,
    machineValues,
    labelStart,
    labelEnd,
    isEvent,
    isLabel,
    labelSubcategoryValues,
    minValue,
    maxValue,
    q,
  ]);

  return (
    <>
      <ModalWrap
        open={openSelectAllResults}
        onCancel={onCancel}
        title={t("dataExplorer.collection.saveAll.title")}
        cta={t("save")}
        onSubmit={onSubmit}
        submitDisabled={!nameValue}
      >
        <Box m={2}>
          <TextField
            label={t("dataExplorer.collection.saveAll.label")}
            value={nameValue}
            id="saveAll"
            onChange={({ target }) => setNameValue(target.value)}
            className={classes.inputWrapper}
            variant="outlined"
            size="small"
            style={{ paddingRight: 10 }}
            required
          />
        </Box>
      </ModalWrap>
    </>
  );
};
export default SaveCollectionClassModal;
